import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@emotion/react';
import { Analytics } from "@vercel/analytics/react"
// Import the section components
import HomeSection from './sections/HomeSection';
import UniverseSection from './sections/UniverseSection';

import AboutSection from './sections/AboutSection';

// Import the new BookPage component (we'll create this next)
import ShardSeriesBook1 from './pages/ShardSeriesBook1';
import ShardSeriesBook2 from './pages/ShardSeriesBook2';
import ShardSeriesBook3 from './pages/ShardSeriesBook3';

// Theme setup
export const themeOptions = createTheme({
  palette: {
    primary: {
      main: '#000000ff',
    },
    secondary: {
      main: '#55DEF1',
    },
  },
  typography: {
    fontFamily: 'Oswald, sans-serif',
  },
});

// Main App Component
const App: React.FC = () => {
  return (
    <ThemeProvider theme={themeOptions}>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<HomeSection />} />
            
            {/* Dynamic route for individual books */}
            <Route path="/books/shard-awakening" element={<ShardSeriesBook1 />} />
            <Route path="/books/shard-series-2" element={<ShardSeriesBook2 />} />
            <Route path="/books/shard-series-3" element={<ShardSeriesBook3 />} />
            <Route path="/universe" element={<UniverseSection />} />

            <Route path="/about" element={<AboutSection />} />

        </Routes>
      </BrowserRouter>
      <Analytics/>
    </ThemeProvider>
  );
};

export default App;
